<ng-container *ngIf="order$ | async as order">
  <div class="saved-cart-details-header">
    <div class="saved-cart-details-title">
      <h1>{{ 'cart.savedCart.details.headerTitle' | cxTranslate }}</h1>
    </div>
    <div class="saved-cart-details-export">
      <app-cart-export [cartId]="cartId"></app-cart-export>
    </div>
  </div>
  <div class="saved-cart-item-list-wrapper">
    <ng-container *ngFor="let item of order?.savedCartData?.entries; let i = index">
      <div class="saved-cart-item-list-row">
        <div class="scd-details">
          <div class="scd-prod-details">
            <div class="scd-image">
              <cx-media
                *ngIf="item?.product?.images; else noImage"
                [container]="getImageRendition((item?.product?.images)[0])"
                format="product"
                [class.is-missing-fish]="businessType === 'fish'"
              ></cx-media>
              <ng-template #noImage>
                <cx-media class="cx-no-image is-missing" [class.is-missing-fish]="businessType === 'fish'"></cx-media>
              </ng-template>
            </div>
            <div class="scd-desc">
              <!-- Item sku -->
              <div class="scd-sku">
                <span class="sku"> {{ item?.product?.code }} </span>
                <ng-container *ngIf="item?.product?.manualAllocation; else productItems">
                  <span class="no-stock">
                    {{ 'product.noStock' | cxTranslate }}
                  </span>
                </ng-container>
                <ng-template #productItems>
                  <ng-container [ngSwitch]="(item?.product)['inStockFlag']">
                    <span class="in-stock" *ngSwitchCase="true">
                      {{ 'product.inStock' | cxTranslate }}
                    </span>
                    <ng-container *ngSwitchCase="false">
                      <ng-container *ngIf="!isDiscontinued(item?.product.stock.stockLevelStatus); else discontinued">
                        <span class="no-stock">
                          {{ 'product.noStock' | cxTranslate }}
                        </span>
                      </ng-container>
                      <ng-template #discontinued>
                        <span class="discontinued">
                          {{ 'product.discontinued' | cxTranslate }}
                        </span>
                      </ng-template>
                    </ng-container>
                  </ng-container>
                </ng-template>
              </div>
              <!-- Item name -->
              <div class="scd-name" [innerHTML]="item?.product?.name"></div>
              <!-- Item color -->
              <div class="scd-color">
                <div class="global-variant" *ngIf="item?.product?.superCategories">
                  <ng-container
                    *ngFor="
                      let variant of checkVariant(item?.product?.superCategories);
                      let index = index;
                      let last = last
                    "
                  >
                    <ng-container *ngIf="!last; else lastItem"
                      >{{ variant.parentCategoryName }}: {{ variant.name }};
                    </ng-container>
                    <ng-template #lastItem>{{ variant.parentCategoryName }}: {{ variant.name }}</ng-template>
                  </ng-container>

                  <!-- In ticket GB2B-26444, this is to display JAN code on the Japan site only -->
                  <ng-container *ngIf="janCodeEnabled">
                    <div class="jan-code">
                      <div class="label">
                        {{ 'cart.cartItem.jan' | cxTranslate }}
                        <span class="attr-value" *ngIf="item.product?.jan || item.product?.ean">
                          {{ item.product?.jan || item.product?.ean }}
                        </span>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <div class="scd-prod-prices">
            <!-- Item srp - in ticket GB2B-4539, this should not display, hide it just incase they need to show this again-->
            <div class="scd-srp">
              <div class="label">{{ 'cart.savedCart.details.srp' | cxTranslate }}</div>
              <div class="value">{{ item?.product?.srpPrice?.formattedValue }}</div>
            </div>

            <!-- Item base price - in ticket GB2B-4539, this should not display, hide it just incase they need to show this again -->
            <div class="scd-base-price">
              <div class="label" *ngIf="!showSrp">{{ 'cart.savedCart.details.basePrice' | cxTranslate }}</div>
              <div class="value" *ngIf="!showSrp">{{ item?.product?.basePrice?.formattedValue }}</div>
            </div>

            <!-- Item dealer price -->
            <div class="scd-dealer-price">
              <div class="label">{{ 'cart.savedCart.details.dealerPrice' | cxTranslate }}</div>
              <div
                class="value"
                *ngIf="!showSrp"
                [ngClass]="{
                  'promo-version':
                    (item?.product?.potentialPromotions && item?.product?.potentialPromotions.length > 0) ||
                    (item?.promotionMessage && item?.promotionMessage !== '')
                }"
              >
                <div
                  class="spinner-shimano-wrapper-dp"
                  *ngIf="!dealerPrice(item?.product?.code); else dealerPriceReady"
                >
                  <ng-container *ngIf="tooltipIconConfig$ | async as tooltipIconConfig">
                    <div class="spinner-shimano" *ngIf="hasDealerPrice">
                      <div class="spinner-shimano-mt-ml"></div>
                    </div>
                    <div
                      class="no-dealer-price no-dealer-price-cs-cm"
                      *ngIf="!hasDealerPrice && !tooltipIconConfig?.enabled; else noDealerPriceTooltip"
                    ></div>
                    <ng-template #noDealerPriceTooltip>
                      <app-tooltip-icon
                        *ngIf="!hasDealerPrice && tooltipIconConfig?.enabled"
                        [noDealerPriceIcon]="tooltipIconConfig?.noDealerPriceIcon"
                        dealerPriceIconContainerClass="no-dealer-price-cs-cm"
                        placement="bottom-right"
                        [tooltipContent]="'tooltip.hasNoDealerPrice' | cxTranslate"
                        [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
                      ></app-tooltip-icon>
                    </ng-template>
                  </ng-container>
                </div>
                <ng-template #dealerPriceReady>
                  <ng-container *ngIf="item.updateable && item.totalPrice.value > 0; else elseBlockBase">
                    {{ item.basePrice?.formattedValue }}
                    <span *ngIf="item.basePrice?.formattedValue && showGstExclusive$ | async" class="gst-label">{{
                      'gst.exclusive' | cxTranslate
                    }}</span>
                    <app-erp-promotional-text [product]="item"></app-erp-promotional-text>
                  </ng-container>
                  <ng-template #elseBlockBase>
                    {{ item.totalPrice.formattedValue }}
                    <span *ngIf="item.totalPrice.formattedValue && showGstExclusive$ | async" class="gst-label">{{
                      'gst.exclusive' | cxTranslate
                    }}</span>
                    <app-erp-promotional-text [product]="item"></app-erp-promotional-text>
                  </ng-template>
                </ng-template>
              </div>
            </div>

            <!-- Item qty -->
            <div class="scd-qty">
              <input disabled value="{{ item?.quantity }}" type="number" min="1" max="999" step="1" />
            </div>

            <!-- Item total -->
            <div class="scd-total">
              <div class="label">{{ 'cart.savedCart.details.total' | cxTranslate }}</div>
              <div class="value" *ngIf="!showSrp">
                {{ item?.totalPrice?.formattedValue }}
                <span *ngIf="item?.totalPrice?.formattedValue && showGstExclusive$ | async" class="gst-label">{{
                  'gst.exclusive' | cxTranslate
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="scd-memo-entry" *ngIf="shimanoMemoEnabled">
          <div class="scd-memo">
            <mat-form-field appearance="outline">
              <input
                readonly
                matInput
                value="{{ item?.memo }}"
                placeholder=""
                class="memoInput"
                #tooltip="matTooltip"
                (mouseover)="showMemoTooltip($event, tooltip)"
                (click)="showMemoTooltip($event, tooltip, 2000)"
                matTooltip="{{ memoIsTruncated ? item?.memo : null }}"
                matTooltipClass="memo-tooltip"
                matTooltipPosition="below"
              />
            </mat-form-field>
          </div>
        </div>
        <!-- Item lead time + Promotional text -->
        <div
          class="scd-footer"
          [class.no-lead-time]="
            !item?.product?.leadTime ||
            !item?.product?.dateLeadTime ||
            !item?.product?.monthLeadTime ||
            !(
              item.product?.stock.stockLevelStatus === 'inStock' || item.product?.stock.stockLevelStatus === 'backorder'
            )
          "
        >
          <div
            class="scd-lead-time"
            *ngIf="
              (item?.product?.leadTime && item?.product?.dateLeadTime && item?.product?.monthLeadTime) ||
              item.product?.stock.stockLevelStatus === 'inStock' ||
              item.product?.stock.stockLevelStatus === 'backorder'
            "
          >
            <ng-container *ngIf="showWarehouseFeature$ | async; else showLeadTime">
              <ng-container
                *ngIf="
                  item.product?.stock.stockLevelStatus === 'backorder' &&
                  item.product?.stock.stockLevel === 0 &&
                  item.product?.monthLeadTime
                "
              >
                <div class="label">{{ 'cart.cartItem.dateLeadTime.title' | cxTranslate }}</div>
                <div class="value">{{ item.product?.monthLeadTime }}</div>
              </ng-container>
            </ng-container>
            <ng-template #showLeadTime>
              <ng-container *ngIf="item.product?.leadTime">
                <div
                  class="label"
                  *ngIf="
                    item.product?.stock.stockLevelStatus === 'inStock' ||
                    item.product?.stock.stockLevelStatus === 'backorder'
                  "
                >
                  {{ 'cart.cartItem.leadtime.title' | cxTranslate }}
                </div>
                <div class="value" *ngIf="item.product?.stock.stockLevelStatus === 'inStock'">
                  {{ 'cart.cartItem.leadtime.value.instock' | cxTranslate : { time: item.product?.leadTime } }}
                  {{ 'cart.cartItem.leadtime.value.day' | cxTranslate }}
                </div>
                <div class="value" *ngIf="item.product?.stock.stockLevelStatus === 'backorder'">
                  {{ 'cart.cartItem.leadtime.value.backorder' | cxTranslate : { time: item.product?.leadTime } }}
                  {{ 'cart.cartItem.leadtime.value.day' | cxTranslate }}
                </div>
              </ng-container>
            </ng-template>
          </div>
          <app-promotional-text
            *ngIf="!showSrp"
            [product]="item?.product"
            [cartItem]="item"
            [orderEntryNumber]="item.entryNumber"
            [appliedProductPromotions]="order?.savedCartData?.appliedProductPromotions"
            [promotionLocation]="'SAVEDCARTDETAILS'"
          ></app-promotional-text>
        </div>
      </div>
    </ng-container>
    <app-cart-export class="mobile-cart-export" [cartId]="cartId"></app-cart-export>
  </div>
</ng-container>
